import React, { Component } from 'react';
import { connect } from 'react-redux';

import { RootState } from '@share/utils';
import { ILoginState, IMenuState } from '@share/store/slices';
import { DailyBenefitsItems, DailyBenefitsHeading } from '@components';
import { IAccount, INavigationItem } from '@share/common-types';

import { SkeletonItems } from '../skeleton-daily-benefits-items';

import './style.scss';

interface IMapStateToProps {
  loginStore: ILoginState;
  menuStore: IMenuState;
}

interface IProps extends IMapStateToProps {}

const DailyBenefits = 'Daily Benefits';
const MoreBenefits = 'More Benefits';
const ZERO = 0;

export class DailyBenefitsWrapperComponent extends Component<IProps> {
  findDailyBenefits = (): INavigationItem => {
    const headerDailyBenefits = this.props.menuStore?.items?.header.filter(
      (item) => item.title === DailyBenefits
    )[ZERO];

    if (headerDailyBenefits && !headerDailyBenefits.childItems?.length) {
      const mainDailyBenefits = this.props.menuStore?.items?.main.filter((item: any) => item.title === MoreBenefits)
        [ZERO].childItems?.filter((item) => item.title === DailyBenefits)[ZERO];

      return mainDailyBenefits as INavigationItem;
    }

    return headerDailyBenefits as INavigationItem;
  };

  render(): React.ReactNode {
    const { account } = this.props.loginStore;
    const { loading, items } = this.props.menuStore;
    const benefits = this.findDailyBenefits()?.childItems;

    return (
      <>
        <DailyBenefitsHeading />
        {loading ? <SkeletonItems /> : <DailyBenefitsItems account={account as IAccount} isMLM={items?.isMLM as boolean} items={benefits as INavigationItem[]} />}
      </>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
    menuStore: state.navigationMenuStore,
  };
};

export const DailyBenefitsWrapper = connect(mapStateToProps)(DailyBenefitsWrapperComponent);
